module.exports = __webpack_public_path__ + "static/media/custom-app-development.ceb5c315.png";